import { errorBoundry, pipe } from "./composition.js";
import { reduce } from "./reduce.js";
import { isPromise } from "./promise.js";
const mapWithoutStack = (f) => (xs) => {
    const results = [];
    for (const x of xs) {
        results.push(f(x));
    }
    // @ts-expect-error ts cannot reason about this dynamic ternary
    return results.some(isPromise) ? Promise.all(results) : results;
};
export const map = (...fs) => errorBoundry(mapWithoutStack(...fs));
export const each = (f) => 
// @ts-expect-error ts cannot reason about this
(xs) => {
    const results = [];
    for (const x of xs) {
        const result = f(x);
        if (isPromise(result))
            results.push(result);
    }
    // @ts-expect-error ts cannot reason about this dynamic ternary
    if (results.length)
        return Promise.all(results).then();
};
export const mapCat = (f) => (x) => pipe(map(f), reduce((a, b) => a.concat(b), () => []))(x);
